
import React, {Component} from 'react';
import {Modal,Button} from 'react-bootstrap'
import { QRCode } from 'react-qr-svg';
import FontAwesome from 'react-fontawesome'
import html2canvas from 'html2canvas'
import Canvas2Image from './Canvas2Image'


class EmployeeQRCodeModal extends Component {

  constructor(...args){
    super(...args)
    this.state = {}
  }

  onDownloadClick(){
    html2canvas(document.querySelector("#qr_capture")).then(canvas => {
      //document.getElementById('qr_canvas').appendChild(canvas);
      //Canvas2Image.saveAsImage(canvas, 256, 320,'png')
    });
  }

  renderQR(){
    let {value,label,subLabel} = this.props
    if(value!==''){
      return (
            <div id='qr_capture' style={{width:'256px',height:'320px',display:'inline-block'}}>
              <QRCode
                      bgColor="#FFFFFF"
                      fgColor="#000000"
                      level="Q"
                      style={{ width: 256 }}
                      value={value}
                  />
              <div>
                <h4>{label}</h4>
                <h4>{subLabel}</h4>
              </div>
              <div id='qr_canvas'/>
            </div>
      )
    }else{
      return(
      <div>
        <span className='text-red'>มีข้อผิดพลาด ไม่พบ URL ติดต่อแอดมิน</span>
      </div>
      )
    }
  }

  render(){
    let {show,title,value} = this.props
    
    return (
      <Modal show={show} enforceFocus={false} onHide={this.props.onHide} dialogClassName="smallwidth-dialog">
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='text-center'>
            {this.renderQR()}            
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button style={{display:'none'}} onClick={this.onDownloadClick.bind(this)}><FontAwesome name='download'/>ดาวโหลดไฟล์</Button>
          <Button onClick={this.props.onHide}><FontAwesome name='close'/>ปิดหน้าต่าง</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

EmployeeQRCodeModal.defaultProps = {
  title: 'QR Code',  
  value :'',
  label:'',
  subLabel:''
}

export default EmployeeQRCodeModal;





// WEBPACK FOOTER //
// ./src/view/hr/EmployeeQRCodeModal.js